import { PropsWithChildren } from "react";

import { rem } from "polished";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { switchProp } from "styled-tools";

import { color, font, spaces } from "emoreg/const";
import { Title } from "styles/atoms";
import { radius } from "styles/const";
import { responsiveHelpers as rh } from "styles/utils";

/**
 * The main component
 * wrap the SidebarBody
 */

const Sidebar = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  ${props => props.isSticky && `position: sticky; top: 100px;`};
  ${rh.belowLandscapeTablet`    
     ${props => props.hideBelowTablet && `display:none;`};
  `}
`;

// FIXME not legacy anymore
Sidebar.defaultProps = {
  size: "MD",
};

Sidebar.propTypes = {
  size: PropTypes.oneOf(["MD"]),
};

const SidebarBodyInner = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${spaces[32]};
  color: ${color.grey.dark};
  border-radius: ${radius.base};
  margin-bottom: 1.5rem;

  & > div:first-of-type {
    padding-top: ${spaces[8]};
  }
  ${rh.belowPortraitTablet`    
    padding: ${spaces[16]};
    margin-bottom: ${spaces[12]};
  `}

  ${switchProp("size", {
    sm: css`
      padding: ${spaces[24]} ${spaces[16]};
    `,
  })}
`;

// Those props in lowercase are legacy
SidebarBodyInner.propTypes = {
  size: PropTypes.oneOf(["sm", "md"]),
};

const CustomTitle = styled(Title)`
  margin-bottom: 0;
  font-weight: ${font.weight.semiBold};
  ${rh.belowPortraitTablet`    
    font-size: ${rem(18)};
  `}
`;

const SidebarBody = ({
  title,
  size,
  children,
}: PropsWithChildren<{ title?: string; size?: "sm" }>) => (
  <SidebarBodyInner size={size}>
    {title && <CustomTitle type="h4">{title}</CustomTitle>}
    {children}
  </SidebarBodyInner>
);

SidebarBody.propTypes = {
  title: PropTypes.string,
};

export { Sidebar, SidebarBody };
